module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/desktop/3.png?fd02438832dd45f8958d2c1fcf120456";